import React from 'react';

import { Button } from '@qality/common-components/src/atoms/Button';
import { Header } from '@qality/common-components/src/atoms/Header';
import { PageHeader } from '@qality/common-components/src/atoms/PageHeader';
import SectionMessage from '@qality/common-components/src/atoms/atlaskit/SectionMessage';

import {
  ButtonsContainer,
  ImportFailureViewContainer,
} from './ImportFailure.styled';

type Props = {
  errorMessage: string;
  errorCode: number;
  contactSupport: () => void;
  tryAgain: () => void;
};

export const ImportFailureView = ({
  errorMessage,
  errorCode,
  contactSupport,
  tryAgain,
}: Props): JSX.Element => {
  return (
    <ImportFailureViewContainer>
      <PageHeader>Import Test Cases from CSV files</PageHeader>
      <Header spacing='medium'>Import failed</Header>
      <SectionMessage appearance='error'>
        <div>
          <p>
            Something went wrong and we can&apos;t identify why. Please try
            again to import your CSV file.
          </p>
          <p>
            If you need more assistance, you can always contact our Customer
            Care Team.
          </p>
          {errorCode && <p>Error code: {errorCode}</p>}
          {errorMessage && <p>Error message: {errorMessage}</p>}
        </div>
      </SectionMessage>
      <ButtonsContainer>
        <Button mr onClick={contactSupport}>
          Contact Support
        </Button>
        <Button onClick={tryAgain} appearance='primary'>
          Try Again
        </Button>
      </ButtonsContainer>
    </ImportFailureViewContainer>
  );
};
